import { render } from "./ModalTaxInvoice.vue?vue&type=template&id=46e7c130"
import script from "./ModalTaxInvoice.vue?vue&type=script&lang=js"
export * from "./ModalTaxInvoice.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__